<template>
  <div>
    <template v-if="!list.hasSpec">
      <div class="header">
        <div class="imgWrap">
          <img
            :src="list.imgList[0]"
          >
        </div>
        <div class="headerMsg">
          <p class="price">￥{{list.sku[0].goods_price}}</p>
          <p class="KuCun">
            库存：
            <span>{{list.sku[0].stock_num}}</span>
          </p>
        </div>
      </div>
      <div class="content">
        <div class="contentFooter">
          <p></p>
          <van-stepper
            v-model="value"
            :max="list.sku[0].stock_num"
          />
        </div>
      </div>
    </template>
    <template v-if="list.hasSpec">
      <div class="header">
        <div class="imgWrap">
          <img
            :src="goods.image_path!=''? goods.image_path : list.imgList[0]"
          >
        </div>
        <div class="headerMsg">
          <p class="price">￥{{goods.goods_price}}</p>
          <p class="KuCun">
            库存：
            <span>{{goods.stock_num}}</span>
          </p>
        </div>
      </div>
      <div class="content">
        <div v-if="list.specItem.length>1" class="contentBody">
          <div v-for="(item,index) in list.sku" :key="index" class="ItemBody">
            <p>{{item.group_name}}</p>
            <div class="groupWrap">
              <div
                v-for="(items,i) in item.item"
                :key="i"
                class="groupItem"
                :class="i==item.active?'active':''"
                @click="changeItem(index,i)"
              >{{items.spec_value}}</div>
            </div>
          </div>
        </div>
        <div class="contentFooter">
          <p></p>
          <van-stepper
            v-model="value"
            min="1"
            :max="goods.stock_num || 1"
          />
        </div>
      </div>
    </template>
    <div class="footer">
      <button class="addgwc" @click="addGWC()">加入购物车</button>
      <button class="bynow" @click="byNow()">立即购买</button>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Stepper } from "vant";
import Vue from "vue";
import { constants } from 'crypto';
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Stepper);
export default {
  props: ["list", "selskuid"], //{group_id,group_name,spec_items{goods_no,goods_price,goods_weight,goods_weight_g,image_id,image_path,item_id,line_price,spec_value,stock_num}
  data() {
    return {
      value: 1
    };
  },
  computed: {
     goods(){
       for(let i in this.list.specItem){
         if(this.selskuid==this.list.specItem[i].spec_sku_id){
           return this.list.specItem[i].form;
         }
       }
     }
  },
  watch: {},
  created() {},
  activated(){
    console.log(list)
  },
  mounted() {},
  destroyed() {},
  methods: {
    changeItem(index, i) {
      // list.
      this.$emit("changeActive", { specGroup: index, specItem: i });
      this.value = 1;
    },
    byNow() {
      this.$emit("ByNow", { value: this.value });
    },
    addGWC() {
      this.$emit("AddCart", { value: this.value });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../style/skin.less");
.header {
  border: 2px solid @white;
  margin-left: 5px;
  display: flex;
  .imgWrap {
    width: 90px;
    height: 90px;
    margin-top: -41px;
    position: relative;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .headerMsg {
    margin-left: 10px;
    .price {
      color: @text;
      font-size: 20px;
    }
    .KuCun {
      font-size: 12px;
      color: @lightP;
    }
  }
}

.content {
  padding: 12px;
  .contentBody {
    .ItemBody {
      font-size: 12px;
      color: @lightP;
      .groupWrap {
        display: flex;
        flex-flow: wrap;
        padding: 5px 0px;
        .groupItem {
          font-size: 13px;
          height: 27.5px;
          line-height: 27.5px;
          margin-right: 10px;
          // padding: 0px 15px;
          text-align: center;
          border: 1px solid @lightP;
          border-radius: 4px;
          margin-bottom: 5px;
          width: 40%;
        }
        .active {
          color: @white;
          background: @btn;
          border-color: @btn;
        }
      }
    }
  }
}

.footer {
  button {
    width: 50%;
    border: 0px;
    height: 46px;
    font-size: 14px;
    color: @white;
  }
  .addgwc {
    // background: linear-gradient(to right, #fac905 0, #ff9500 100%);
    color: @darkP;
    background: @gray;
  }
  .bynow {
    // background: linear-gradient(to right, #fa1e8c 0, #fc1e56 100%);
    color: @white;
    background: @btn;
  }
}
</style>
<style>
.footerPo1pup /deep/ .van-popup {
  overflow-y: visible !important;
}
</style>